import useSize from "@react-hook/size";
export const usePreciseSize = (target, options) => {
    var _a, _b;
    const _impreciseSize = useSize(target, options);
    if (!target.current) {
        return [(_a = options === null || options === void 0 ? void 0 : options.initialWidth) !== null && _a !== void 0 ? _a : 0, (_b = options === null || options === void 0 ? void 0 : options.initialHeight) !== null && _b !== void 0 ? _b : 0];
    }
    const clientRect = target.current.getBoundingClientRect();
    return [clientRect.width, clientRect.height];
};
